// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__xNVIt","title":"InfoRow_title__3R-Rx"};